<template>
    <np-input v-bind="$attrs"
              :rules="!!$attrs.rules ? $attrs.rules :['is_natural']"
              :required="isRequired"
              :check_config="false"
              :addon-class="addonClass"
              @blur="validateBank($event.target.value)"
              @enter="validateBank"
              @addon-click="validateBank"
              :label="label"
              v-model="keyword"
              @update:modelValue="val => $emit('input', val)">
        <template #addon v-if="bank_valid_status === 3">
            <span ><i class="fa fa-check"> </i></span>
        </template>
        <template #addon v-else-if="bank_valid_status === 2">
            <span class="error" ><i class="fa fa-times"> </i></span>
        </template>
        <template #addon v-else-if="bank_valid_status === 1">
            <span ><i class="fa fa-spinner fa-spin"> </i></span>
        </template>
        <template #addon v-else-if="bank_valid_status === 0 && showValidateButton">
            <span >{{lang('validate')}}</span>
        </template>
    </np-input>
</template>
<script>
    import NPInput from './np-input.vue';
    import NpResponsive from "./np-responsive.vue";
    export default {
        name: 'np-bank',
        emits:['modelValue','bank-validated'],
        props: {
            value: String,
            modelValue:String,
            label: String,
            sortCode: String,
            isIban: {
                default: false
            },
            showValidateButton: {
                default: false,
            },
            reference: {
                default: {},
            },
            required: {
                default: true,
            },
            country: {
                type: String,
                default: 'GBR'
            },
            check_config: {
                default: false
            },
        },
        components: {
            'np-input': NPInput,
        },
        data: function(){
            return {
                bank_valid_status: 0,
                keyword: '',
                is_iban: '',
                addonClass: {},
                bank_cache: {},
                bank_status: {
                    reset: 0,
                    validating: 1,
                    error: 2,
                    success: 3,
                },
                validation_types: {
                    IBAN: 'IBAN',
                    ACCOUNT_NUMBER: 'ACCOUNT_NUMBER'
                },
                default_readonly: false,
                page_config_required: false
            }
        },
        created: function (){
            // This component should word without v-model binding
            //TODO Add the sort code part
            this.keyword = this.modelValue;
        },
        methods: {
            validateBank(bank) {
                let disallowed_validate_account_sort = [`SWE`, `NOR`, `DEU`];  // For sweden used the account sort code not need to be validate
                let disallowed_validate_iban = [`NOR`, `DEU`];  // For Norway not need to be validate IBAN

                let no_validate_account_sort = disallowed_validate_account_sort.includes(this.country);
                // let no_validate_iban = disallowed_validate_iban.includes(this.country);

                let payload = {};
                if (this.isIban) {
                    payload = {
                        type: this.validation_types.IBAN,
                        iban: bank
                    };
                    // check that iban is not blank or valid before making API request
                    if (payload.iban.length === 0) {
                        // this.addonClass = {error: true};
                        // this.bank_valid_status = this.bank_status.error;
                        return;
                    }
                }
                else if (no_validate_account_sort) {
                    return;
                }
                else {
                    payload = {
                        type: this.validation_types.ACCOUNT_NUMBER,
                        sort_code: this.sortCode,
                        account_number: bank
                    };
                    // check that sort code and account number is valid before making API request
                    if (payload.sort_code.length < 6 || payload.account_number.length < 8) {
                        this.addonClass = {error: true};
                        this.bank_valid_status = this.bank_status.error;
                        return;
                    }
                }

                payload = {...payload, ...this.reference, ...{country_code: this.country}}

                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // };

                if (this.bank_cache.hasOwnProperty(this.bankKey) && (this.bank_cache[this.bankKey]['valid'] === true)) {
                    this.bank_valid_status = (this.bank_cache[this.bankKey]['valid'] === true) ? this.bank_status.success : this.bank_status.error;
                } else {
                    this.bank_valid_status = this.bank_status.validating;
                    let vm = this;

                    vm.showPreloader = true;

                    setTimeout(()=>{
                        $("#form").find('input').each(function() {
                            if ($(this).attr('id') !== undefined && $(this).attr('id').indexOf('iban') !== -1) {
                              $(this).tooltip('hide')
                            }
                        });
                    },200)

                    this.getAxiosInstance().post('/externalservices/validatebankaccount', payload)  //, configs)
                        .then(response => {
                            vm.showPreloader = false;
                            const data = response.data;
                            vm.bank_cache[vm.bankKey] = data;
                            vm.bank_valid_status = data['valid'] ? vm.bank_status.success : vm.bank_status.error;
                        })
                        .catch(error => {
                          vm.showPreloader = false;
                          vm.bank_valid_status = vm.bank_status.error;
                        })
                }
            },
        },
        computed: {
            bankKey: function () {
                let bank_key = '';
                if(this.isIban) {
                    bank_key = `${this.validation_types.IBAN}_${this.keyword}`
                } else {
                    bank_key = `${this.validation_types.ACCOUNT_NUMBER}_${this.sortCode}_${this.keyword}`
                }
                return bank_key;
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
        },
        watch: {
            modelValue: function (val) {
                this.bank_valid_status = 0;
                this.keyword = val;
            },
            sortCode: function (val) {
                this.bank_valid_status = 0;
                this.validateBank(this.modelValue);
            },
            bank_valid_status: function (val) {
                if(val === this.bank_status.reset || val === this.bank_status.validating) {
                    this.addonClass = {}
                }
                if(val === this.bank_status.error) {
                    this.addonClass = {error: true}
                    if (this.bank_cache.hasOwnProperty(this.bankKey)
                        && this.bank_cache[this.bankKey].hasOwnProperty('verify')) {
                        let explanation = this.bank_cache[this.bankKey]['verify']['account_details']['explanation'];
                        if (explanation) {
                          let result = explanation.replace(/([A-Z])/g, " $1");
                          this.bank_cache[this.bankKey]['verify']['account_details']['explanation'] = result.charAt(0).toUpperCase() + result.slice(1);
                          this.$emit('bank-validated', this.bank_cache[this.bankKey]['verify']['account_details']);
                        }
                    }
                }
                if(val === this.bank_status.success) {
                    if (this.bank_cache.hasOwnProperty(this.bankKey)
                        && this.bank_cache[this.bankKey].hasOwnProperty('verify')
                        && this.bank_cache[this.bankKey]['verify'].hasOwnProperty('country_code')){
                        Object.assign(this.bank_cache[this.bankKey]['verify']['account_details'], {'country_iso2' : this.bank_cache[this.bankKey]['verify']['country_code']})
                    }
                    this.$emit('bank-validated', this.bank_cache[this.bankKey]['verify']['account_details']);
                    this.addonClass = {success: true}
                }
            }

        }
    }
</script>

<style scoped>

</style>